/*
 * Glow Up 2026 refresh: scroll reveals (styles in refresh-motion.css).
 * Tags refresh-section headings, cards and media, then reveals each as it
 * scrolls into view. Items that come into view together are staggered.
 * Respects the "Reveal sections on scroll" theme setting and reduced motion.
 */
(() => {
  const html = document.documentElement;
  if (!html.classList.contains('hdt-reveal-in-view')) return;
  if (window.Shopify && Shopify.designMode) return;
  if (!('IntersectionObserver' in window)) return;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const TEXT = [
    '.gu-head__text > *', '.gu-head > .gu-link',
    '.gu-hero__inner > *', '.gu-video__inner > *',
    '.gu-split__body > *', '.gu-location__body > *',
    '.gu-coll-hero__text > *', '.gu-person__text > *',
    '.gu-pd__panel > *', '.gu-pdd__text > *', '.gu-pdd__row',
    '.gu-faq__layout > .gu-title', '.gu-faq__item',
    '.gu-team > * > .gu-eyebrow', '.gu-team > * > .gu-title', '.gu-team__intro',
    '.gu-finance__row > *', '.gu-values__item',
    '.gu-reviews__card', '.gu-concerns__tile', '.gu-concerns__quiz',
    '.gu-articles__card', '.gu-services__tile', '.gu-team__card',
    '.gu-coll__grid > li', '.gu-booking__row > *',
    '.gu-footer__col'
  ].join(',');
  const MEDIA = [
    '.gu-split__media', '.gu-location__media', '.gu-coll-hero__media',
    '.gu-person__photo', '.gu-pd__media', '.gu-ba__compare'
  ].join(',');
  const STAGGER = 110;
  const MAX_DELAY = 660;

  // Swipe rows reveal as one group: cards scrolled off to the side never intersect
  const groups = new Map();
  const observer = new IntersectionObserver((entries) => {
    let i = 0;
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      (groups.get(entry.target) || [entry.target]).forEach((el) => {
        el.style.setProperty('--gu-rv-delay', `${Math.min(i++ * STAGGER, MAX_DELAY)}ms`);
        el.classList.add('is-in');
        el.addEventListener('animationend', (e) => {
          if (e.target === el) el.style.removeProperty('--gu-rv-delay');
        }, { once: true });
      });
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

  const tag = (el, cls) => {
    if (el.classList.contains('gu-rv') || el.classList.contains('gu-rv-media')) return;
    el.classList.add(cls);
    const row = el.parentElement && el.parentElement.closest('.gu-swipe, .gu-swipe-mobile');
    if (row && row === el.parentElement) {
      if (!groups.has(row)) { groups.set(row, []); observer.observe(row); }
      groups.get(row).push(el);
    } else {
      observer.observe(el);
    }
  };

  const scope = document.querySelectorAll('#MainContent, .shopify-section-group-footer-group');
  scope.forEach((root) => {
    root.querySelectorAll(MEDIA).forEach((el) => tag(el, 'gu-rv-media'));
    root.querySelectorAll(TEXT).forEach((el) => {
      if (!el.closest('.gu-rv-media, dialog') && !el.parentElement.closest('.gu-rv')) tag(el, 'gu-rv');
    });
  });
})();
